import { FC, memo } from 'react';

import { Root } from './NestedMenuItem.styles';
import { NestedMenuItemProps } from './NestedMenuItem.types';

export const NestedMenuItem: FC<NestedMenuItemProps> = memo((props) => {
    const { nestingLevel, ...restProps } = props;

    return <Root {...restProps} $nestingLevel={nestingLevel} />;
});

NestedMenuItem.displayName = 'NestedMenuItem';
